// API related actions
export const FETCHING_USERS_LIST = '@@toyota/FETCHING_USERS_LIST';
export const FETCHED_USERS_LIST = '@@toyota/FETCHED_USERS_LIST';
export const FETCHED_USERS_LIST_FAILED = '@@toyota/FETCHED_USERS_LIST_FAILED';

export const FETCHING_USERS_POLICIES_LIST = '@@toyota/FETCHING_USERS_POLICIES_LIST';
export const FETCHED_USERS_POLICIES_LIST = '@@toyota/FETCHED_USERS_POLICIES_LIST';
export const FETCHED_USERS_POLICIES_LIST_FAILED = '@@toyota/FETCHED_USERS_POLICIES_LIST_FAILED';

export const FETCHING_USERS_REQUESTS_LIST = '@@toyota/FETCHING_USERS_REQUESTS_LIST';
export const FETCHED_USERS_REQUESTS_LIST = '@@toyota/FETCHED_USERS_REQUESTS_LIST';
export const FETCHED_USERS_REQUESTS_LIST_FAILED = '@@toyota/FETCHED_USERS_REQUESTS_LIST_FAILED';

export const FETCHING_USERS_PERMISSIONS_LIST = '@@toyota/FETCHING_USERS_PERMISSIONS_LIST';
export const FETCHED_USERS_PERMISSIONS_LIST =
  '@@toyota/FETCHED_USERS_PERMISSIONS_LIST';
export const FETCHED_USERS_PERMISSIONS_LIST_FAILED = '@@toyota/FETCHED_USERS_PERMISSIONS_LIS_LIST_FAILED';

export const FETCHING_USER_REQUEST_INFO = '@@toyota/FETCHING_USER_REQUEST_INFO';
export const FETCHED_USER_REQUEST_INFO = '@@toyota/FETCHED_USER_REQUEST_INFO';
export const FETCHED_USER_REQUEST_INFO_FAILED =
  '@@toyota/FETCHED_USER_REQUEST_INFO_FAILED';

export const CHECKING_USER_INFO = '@@toyota/CHECKING_USERS_INFO';
export const CHECKED_USER_INFO = '@@toyota/CHECKED_USERS_INFO';
export const CHECKED_USER_INFO_FAILED = '@@toyota/CHECKED_USERS_INFO_FAILED';

export const ADDING_USER_REQUEST = '@@toyota/ADDING_USER_REQUEST';
export const ADDED_USER_REQUEST = '@@toyota/ADDED_USER_REQUEST';
export const ADDED_USER_REQUEST_FAILED = '@@toyota/ADDED_USER_REQUEST_FAILED';

export const ADDING_NEW_USER = '@@toyota/ADDING_NEW_USER';
export const ADDED_NEW_USER = '@@toyota/ADDED_NEW_USER';
export const ADDED_NEW_USER_FAILED = '@@toyota/ADDED_NEW_USER_FAILED';

export const UPDATING_USER_REQUEST = '@@toyota/UPDATING_USER_REQUEST';
export const UPDATED_USER_REQUEST = '@@toyota/UPDATED_USER_REQUEST';
export const UPDATED_USER_REQUEST_FAILED = '@@toyota/UPDATED_USER_REQUEST_FAILED';

export const CLEAR_USER_FORM = '@@toyota/CLEAR_USER_FORM';
export const CLEAR_USER_LIST = '@@toyota/CLEAR_USER_LIST';
export const CLEAR_USER_REQUESTS_LIST = '@@toyota/CLEAR_USER_REQUESTS_LIST';

export const FETCHING_USER = '@@toyota/FETCHING_USER';
export const FETCHED_USER = '@@toyota/FETCHED_USER';
export const FETCHED_USER_FAILED = '@@toyota/FETCHED_USER_FAILED';

export const UPDATING_USER = '@@toyota/FETCHED_USER_FAILED';
export const UPDATED_USER = '@@toyota/FETCHED_USER_FAILED';
export const UPDATED_USER_FAILED = '@@toyota/FETCHED_USER_FAILED';

export const FETCHING_USERS_FROM_DIRECTORY = '@@toyota/FETCHING_USERS_FROM_DIRECTORY';
export const FETCHED_USERS_FROM_DIRECTORY = '@@toyota/FETCHED_USERS_FROM_DIRECTORY';
export const FETCHED_USERS_FROM_DIRECTORY_FAILED =
  '@@toyota/FETCHED_USERS_FROM_DIRECTORY_FAILED';

export const SET_USER_FROM_DIRECTORY = '@@toyota/SET_USER_FROM_DIRECTORY';
export const SET_USER_FIELD_VALUE = '@@toyota/SET_USER_FIELD_VALUE';
export const SET_USER_TDE_NEW = '@@toyota/SET_USER_TDE_NEW';
